import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import { buildCanonicalUrl } from "lib/seo";

import { objectToQueryString } from "membership-ui/login/utils/utils";
import {
  BriefingsAboutData,
  fetchBriefingsAboutPageData,
} from "content-ui/briefings/fetchers/briefingsAboutFetcher";
import { fetchNavbarAndFooter } from "lib/fetchers/common";
import BriefingsAboutView from "content-ui/briefings/briefingsAboutView";

import PreviewModeBanner from "components/previewModeBanner/previewModeBanner";
import ErrorBoundary from "components/errorBoundary/errorBoundary";
import Navigation from "components/navigation/navigation";
import Footer from "components/footer/footer";

export async function getServerSideProps({ res, preview = false }) {
  const [menuItems, pageData] = await Promise.all([
    fetchNavbarAndFooter(),
    fetchBriefingsAboutPageData({ preview }),
  ]);

  res.setHeader(
    "Cache-Control",
    "public, s-maxage=10, stale-while-revalidate=59"
  );

  return {
    props: {
      pageData: pageData,
      previewMode: preview,
      __initialState: {
        sitewideOption: { ...menuItems },
      },
    },
  };
}

export type BriefingsPageProps = {
  previewMode: boolean;
  pageData: BriefingsAboutData;
};

const BriefingsPage = (props: BriefingsPageProps) => {
  const { pageData } = props;

  const seoImage = `${pageData.seo.image.url}?${objectToQueryString({
    w: "1200",
    h: "628",
    q: "75",
    fit: "crop",
    auto: "format,compress",
  })}`;

  return (
    <>
      <Head>
        {generateNextSeo({
          canonical: buildCanonicalUrl("/pro/briefings/about"),
          openGraph: {
            title: pageData.seo.title,
            description: pageData.seo.description,
            images: [{ url: seoImage }],
          },
          twitter: {
            handle: "@siftedeu",
            site: "@siftedeu",
            cardType: "summary_large_image",
          },
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Navigation />
      {props.previewMode ? (
        <PreviewModeBanner exitSlug={`/pro/briefings`} />
      ) : null}
      <ErrorBoundary>
        <BriefingsAboutView {...pageData} />
      </ErrorBoundary>
      <Footer />
    </>
  );
};

export default BriefingsPage;
